import React, { useReducer, useEffect, useState, useRef } from "react";
import {
	Box,
	MenuItem,
	InputLabel,
	Select,
	Typography,
	styled,
	Container,
	TextField,
	Autocomplete,
	FormHelperText,
	Grid,
	CircularProgress,
	InputAdornment,
	FormControl,
	Tabs,
	Tab,
	Button
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { useLocation, useNavigate } from "react-router-dom";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import {
	StyledTextField,
	StyledFormControl,
	FormContainer,
	StyledButton,
	FormGrid,
} from "../../common/FormStyles";
import {
	getCitiesList,
	getLocationData,
	getReligionsList,
	getCountriesList,
	getCastesList,
	getMusicList,
	getHobbiesList,
	updatePersonalDetails,
	getMotherTongueList,
	getStarList,
	getMoonsignList,
	getInterestsList,
	getCuisineList,
	getReadsList,
	getSportsList,
	getMoviesList,
	getDressStyleList,
	getLanguageList,
	getApplicationForList,
	getSourceList,
	getNearestBranchList,
	getProfileDetails,
	getHealthConditionList,
	getSubCatesList,
	getCitiesListByCountry,
	getStatesListByCountry,
	getDistrictsListByState,
	getCitiessListByDistrict,
	updateNewContactDetails,
	updateNewPrsonalDetails,
	updateNewCostDetails,
	updateNewLifeDetails,
	updateNewCApplicationDetails,
	nearestBranch,
	fetchCastesByReligionId,
	personalCertificatesUpload,
	uploadProfilePic,
	uploadIdProof
} from "../../../services/operations/userOperations";
import CustomAlert from "../../common/CustomAlert";
import dayjs from "dayjs";
import { setFormData, getFormData } from "../../../utils/localStorageManager";
import PhoneInput from "react-phone-input-2";
import utc from 'dayjs/plugin/utc';
import { showError, showSuccess } from "../userdashbord/sweetAlert/sweetAlert";
import { differenceInYears, subYears, parseISO } from 'date-fns';
const SectionTitle = styled(Typography)(({ theme }) => ({
	fontWeight: "600",
	fontSize: "16px",
	marginBottom: theme.spacing(2),
	marginTop: theme.spacing(2),
	color: "#333333",
}));

export const bloodGroups = [
	{ id: "A+", name: "A+" },
	{ id: "A-", name: "A-" },
	{ id: "B+", name: "B+" },
	{ id: "B-", name: "B-" },
	{ id: "AB+", name: "AB+" },
	{ id: "AB-", name: "AB-" },
	{ id: "O+", name: "O+" },
	{ id: "O-", name: "O-" },
];
export const hobbies = [
	{ id: "Playing Cricket", name: "Playing Cricket" },
	{ id: "Painting", name: "Painting" },
	{ id: "Gardening", name: "Gardening" },
	{ id: "Photography", name: "Photography" },
	{ id: "Cooking", name: "Cooking" },
	{ id: "Dancing", name: "Dancing" },
	{ id: "Writing", name: "Writing" },
	{ id: "Knitting", name: "Knitting" },
	{ id: "Origami", name: "Origami" },
	{ id: "Board Games", name: "Board Games" },
	{ id: "DIY Projects", name: "DIY Projects" },
	{ id: "Bird Watching", name: "Bird Watching" }
];
export const interests = [
	{ id: "Technology", name: "Technology" },
	{ id: "Travel", name: "Travel" },
	{ id: "Art", name: "Art" },
	{ id: "Science", name: "Science" },
	{ id: "History", name: "History" },
	{ id: "Psychology", name: "Psychology" },
	{ id: "Spirituality", name: "Spirituality" },
	{ id: "Philosophy", name: "Philosophy" },
	{ id: "Nature", name: "Nature" },
	{ id: "Animals", name: "Animals" },
	{ id: "Gaming", name: "Gaming" },
	{ id: "Politics", name: "Politics" }
];
export const favouriteMusic = [
	{ id: "Rock", name: "Rock" },
	{ id: "Jazz", name: "Jazz" },
	{ id: "Classical", name: "Classical" },
	{ id: "Hip Hop", name: "Hip Hop" },
	{ id: "Pop", name: "Pop" },
	{ id: "Country", name: "Country" },
	{ id: "Reggae", name: "Reggae" },
	{ id: "EDM", name: "EDM" },
	{ id: "Blues", name: "Blues" },
	{ id: "Metal", name: "Metal" },
	{ id: "Soul", name: "Soul" },
	{ id: "Folk", name: "Folk" }
];
export const sports = [
	{ id: "Cricket", name: "Cricket" },
	{ id: "Football", name: "Football" },
	{ id: "Basketball", name: "Basketball" },
	{ id: "Tennis", name: "Tennis" },
	{ id: "Swimming", name: "Swimming" },
	{ id: "Badminton", name: "Badminton" },
	{ id: "Table Tennis", name: "Table Tennis" },
	{ id: "Golf", name: "Golf" },
	{ id: "Wrestling", name: "Wrestling" },
	{ id: "Boxing", name: "Boxing" },
	{ id: "Skating", name: "Skating" },
	{ id: "Hockey", name: "Hockey" }
];
export const fitnessActivities = [
	{ id: "Yoga", name: "Yoga" },
	{ id: "Gym", name: "Gym" },
	{ id: "Running", name: "Running" },
	{ id: "Cycling", name: "Cycling" },
	{ id: "Pilates", name: "Pilates" },
	{ id: "Swimming", name: "Swimming" },
	{ id: "Zumba", name: "Zumba" },
	{ id: "CrossFit", name: "CrossFit" },
	{ id: "Hiking", name: "Hiking" },
	{ id: "Home Workouts", name: "Home Workouts" },
	{ id: "Dance Fitness", name: "Dance Fitness" },
	{ id: "Martial Arts", name: "Martial Arts" }
];
export const favouriteCuisine = [
	{ id: "Italian", name: "Italian" },
	{ id: "Chinese", name: "Chinese" },
	{ id: "Indian", name: "Indian" },
	{ id: "Mexican", name: "Mexican" },
	{ id: "Thai", name: "Thai" },
	{ id: "Japanese", name: "Japanese" },
	{ id: "Greek", name: "Greek" },
	{ id: "French", name: "French" },
	{ id: "Korean", name: "Korean" },
	{ id: "Spanish", name: "Spanish" },
	{ id: "Middle Eastern", name: "Middle Eastern" },
	{ id: "Lebanese", name: "Lebanese" }
];
export const favouriteReads = [
	{ id: "Fiction", name: "Fiction" },
	{ id: "Non-fiction", name: "Non-fiction" },
	{ id: "Biography", name: "Biography" },
	{ id: "Science Fiction", name: "Science Fiction" },
	{ id: "Mystery", name: "Mystery" },
	{ id: "Fantasy", name: "Fantasy" },
	{ id: "Romance", name: "Romance" },
	{ id: "Self-help", name: "Self-help" },
	{ id: "Historical", name: "Historical" },
	{ id: "Philosophy", name: "Philosophy" },
	{ id: "Poetry", name: "Poetry" },
	{ id: "Graphic Novels", name: "Graphic Novels" }
];
export const preferredMovies = [
	{ id: "Action", name: "Action" },
	{ id: "Comedy", name: "Comedy" },
	{ id: "Drama", name: "Drama" },
	{ id: "Romance", name: "Romance" },
	{ id: "Thriller", name: "Thriller" },
	{ id: "Sci-fi", name: "Sci-fi" },
	{ id: "Fantasy", name: "Fantasy" },
	{ id: "Horror", name: "Horror" },
	{ id: "Documentary", name: "Documentary" },
	{ id: "Animation", name: "Animation" },
	{ id: "Adventure", name: "Adventure" },
	{ id: "Musical", name: "Musical" }
];
export const preferredDressStyle = [
	{ id: "Casual", name: "Casual" },
	{ id: "Formal", name: "Formal" },
	{ id: "Sporty", name: "Sporty" },
	{ id: "Ethnic", name: "Ethnic" },
	{ id: "Trendy", name: "Trendy" },
	{ id: "Traditional", name: "Traditional" },
	{ id: "Bohemian", name: "Bohemian" },
	{ id: "Streetwear", name: "Streetwear" },
	{ id: "Vintage", name: "Vintage" },
	{ id: "Chic", name: "Chic" }
];
export const favouriteFood = [
	{ id: "Pizza", name: "Pizza" },
	{ id: "Biryani", name: "Biryani" },
	{ id: "Sushi", name: "Sushi" },
	{ id: "Burgers", name: "Burgers" },
	{ id: "Pasta", name: "Pasta" },
	{ id: "Tacos", name: "Tacos" },
	{ id: "Noodles", name: "Noodles" },
	{ id: "Fried Chicken", name: "Fried Chicken" },
	{ id: "Paneer Tikka", name: "Paneer Tikka" },
	{ id: "Ice Cream", name: "Ice Cream" },
	{ id: "Salad", name: "Salad" },
	{ id: "Steak", name: "Steak" }
];
export const spokenLanguages = [
	{ id: "English", name: "English" },
	{ id: "Hindi", name: "Hindi" },
	{ id: "Spanish", name: "Spanish" },
	{ id: "French", name: "French" },
	{ id: "German", name: "German" },
	{ id: "Mandarin", name: "Mandarin" },
	{ id: "Arabic", name: "Arabic" },
	{ id: "Bengali", name: "Bengali" },
	{ id: "Russian", name: "Russian" },
	{ id: "Portuguese", name: "Portuguese" },
	{ id: "Punjabi", name: "Punjabi" },
	{ id: "Tamil", name: "Tamil" }
];

// const motherTongues = [
// 	{ id: "telugu", name: "Telugu" },
// 	{ id: "hindi", name: "Hindi" },
// 	{ id: "tamil", name: "Tamil" },
// 	{ id: "kannada", name: "Kannada" },
// 	{ id: "malayalam", name: "Malayalam" },
// ];

// const healthConditions = [
// 	{ id: "excellent", name: "Excellent" },
// 	{ id: "good", name: "Good" },
// 	{ id: "average", name: "Average" },
// 	{ id: "poor", name: "Poor" },
// ];

// const birthPlaces = [
// 	{ id: "hyderabad", name: "Hyderabad" },
// 	{ id: "bangalore", name: "Bangalore" },
// 	{ id: "chennai", name: "Chennai" },
// 	{ id: "mumbai", name: "Mumbai" },
// ];
// const religions = [{ id: "hindu", name: "Hindu" }, { id: "muslim", name: "Muslim" }];
// const castes = [{ id: "brahmin", name: "Brahmin" }, { id: "kamma", name: "Kamma" }];
// const subCastes = [{ id: "niyogi", name: "Niyogi" }];
const convertedCastes = [{ id: 1, name: "Yes" }, { id: 0, name: "No" }];
const casteNotAProblemOptions = [{ id: 1, name: "Yes" }, { id: 0, name: "No" }];
const havingChildrens = [{ id: 1, name: "Yes" }, { id: 0, name: "No" }];
export const khujaDhoshamOptions = [{ id: 1, name: "Yes" }, { id: 0, name: "No" }];
export const padams = [{ id: 1, name: "1" }, { id: 2, name: "2" }, { id: 3, name: "3" }, { id: 4, name: "4" }]
export const maritalStatuses = [
	{ id: "Single", name: "Un Married" },
	// { id: "Married", name: "Married" },
	{ id: "Divorced", name: "Divorced" },
	{ id: "WaitingForDivorce", name: "Waiting for Divorce" },
	{ id: "Widowed", name: "Widowed" },
];

export const smokeOptions = [
	{ id: "yes", name: "Yes" },
	{ id: "no", name: "No" },
	{ id: "occasionally", name: "Occasionally" },
];

export const drinkOptions = [
	{ id: "yes", name: "Yes" },
	{ id: "no", name: "No" },
	{ id: "occasionally", name: "Occasionally" },
];

export const foodPreferences = [
	{ id: "vegetarian", name: "Vegetarian" },
	{ id: "non_vegetarian", name: "Non-Vegetarian" },
	{ id: "eggetarian", name: "Eggetarian" },
	{ id: "vegan", name: "Vegan" },
];

const idProofs = [
	{ id: "Aadhar", name: "Aadhar" },
	{ id: "Pan", name: "PAN" },
	{ id: "Passport", name: "Passport" },
];

const states = [
	{ id: 1, name: "Telangana" },
	{ id: 2, name: "Karnataka" },
	// add more...
];

const districts = [
	{ id: 1, name: "Hyderabad" },
	{ id: 2, name: "Bangalore Urban" },
	// add more...
];

export const heightOptions = [
	{ id: 208, name: `6'10" (208 cm)` },
	{ id: 206, name: `6'9" (206 cm)` },
	{ id: 203, name: `6'8" (203 cm)` },
	{ id: 201, name: `6'7" (201 cm)` },
	{ id: 198, name: `6'6" (198 cm)` },
	{ id: 196, name: `6'5" (196 cm)` },
	{ id: 193, name: `6'4" (193 cm)` },
	{ id: 191, name: `6'3" (191 cm)` },
	{ id: 188, name: `6'2" (188 cm)` },
	{ id: 185, name: `6'1" (185 cm)` },
	{ id: 183, name: `6'0" (183 cm)` },
	{ id: 180, name: `5'11" (180 cm)` },
	{ id: 178, name: `5'10" (178 cm)` },
	{ id: 175, name: `5'9" (175 cm)` },
	{ id: 173, name: `5'8" (173 cm)` },
	{ id: 170, name: `5'7" (170 cm)` },
	{ id: 168, name: `5'6" (168 cm)` },
	{ id: 165, name: `5'5" (165 cm)` },
	{ id: 163, name: `5'4" (163 cm)` },
	{ id: 160, name: `5'3" (160 cm)` },
	{ id: 157, name: `5'2" (157 cm)` },
	{ id: 155, name: `5'1" (155 cm)` },
	{ id: 152, name: `5'0" (152 cm)` },
	{ id: 150, name: `4'11" (150 cm)` },
	{ id: 147, name: `4'10" (147 cm)` },
	{ id: 145, name: `4'9" (145 cm)` },
	{ id: 142, name: `4'8" (142 cm)` },
	{ id: 140, name: `4'7" (140 cm)` },
	{ id: 137, name: `4'6" (137 cm)` },
	{ id: 135, name: `4'5" (135 cm)` },
	{ id: 132, name: `4'4" (132 cm)` },
	{ id: 130, name: `4'3" (130 cm)` },
	{ id: 127, name: `4'2" (127 cm)` },
	{ id: 125, name: `4'1" (125 cm)` },
	{ id: 122, name: `4'0" (122 cm)` },
	{ id: 119, name: `3'11" (119 cm)` },
	{ id: 117, name: `3'10" (117 cm)` },
	{ id: 114, name: `3'9" (114 cm)` },
	{ id: 112, name: `3'8" (112 cm)` },
	{ id: 109, name: `3'7" (109 cm)` },
	{ id: 107, name: `3'6" (107 cm)` },
];

export const complexions = [
	{ id: "VeryFair", name: "Very Fair" },
	{ id: "Fair", name: "Fair" },
	{ id: "Wheatish", name: "Wheatish" },
	{ id: "Dusky", name: "Dusky" },
	{ id: "Dark", name: "Dark" },
];

const noOfChildrens = [{ id: 1, name: "1" }, { id: 2, name: "2" }, { id: 3, name: "3" }, { id: 4, name: "4" }, { id: 5, name: "5" }]
const idProofTypes = [{ id: "aadharNumber", name: "Aadhar" }, { id: "pan", name: "PAN" }, { id: "passport", name: "Passport" }]

const formReducer = (state, action) => {
	switch (action.type) {
		case "SET_FIELD":
			return {
				...state,
				[action.field]: action.value,
			};
		case "SET_LOCATION":
			return {
				...state,
				selectedLocation: action.value,
			};
		case "SET_ERRORS":
			return {
				...state,
				errors: action.errors,
			};
		case "SET_CHILD_INFO":
			const updatedChildren = [...(state.childrenInfo || [])];

			if (!updatedChildren[action.index]) {
				updatedChildren[action.index] = { gender: "", age: "", dependentOn: "" };
			}

			updatedChildren[action.index][action.field] = action.value;

			return {
				...state,
				childrenInfo: updatedChildren,
			};
		default:
			return state;
	}
};


const PersonalDetailsForm = (props) => {
	// const location = useLocation();
	const userType = sessionStorage.getItem("userType")
	const { type, onSubmitSuccess } = props
	const personalDetailsForm = {
		dateOfMarriage: "",
		maritalStatus: null,
		noOfChildren: null,
		havingChildren: null,
		childrenDetails: [],
		aadharNumber: "",
		height: null,
		bloodGroup: null,
		motherTongue: null,
		healthCondition: null,
		aboutMe: "",
		dateOfBirth: "",
		// new Date(
		// 	new Date().setFullYear(new Date().getFullYear() - 18)
		// ),
		timeOfBirth: dayjs(),
		complexion: null,


	}
	const [birthPlace, setBirthPlace] = useState("")
	const [previousProfilePic, setPreviousProfilePic] = useState(null)
	const [previousAadharCard, setPreviousAadharCard] = useState(null)
	const [profileStrength, setProfileStrength] = useState(null)

	const handleChange = (field, value) => {
		setState((prev) => {
			let updated = { ...prev, [field]: value };

			// If user selects "Single", reset and hide child-related fields
			if (field === "maritalStatus" && value?.id === "Single") {
				updated = {
					...updated,
					havingChildren: null,
					noOfChildren: null,
					childrenDetails: [],
				};
			}

			// If selecting number of children, initialize childrenDetails
			if (field === "noOfChildren" && value?.id) {
				const numChildren = parseInt(value.name);
				updated.childrenDetails = Array.from({ length: numChildren }, () => ({
					gender: null,
					age: "",
					dependent: null,
					childMaritalStatus: null
				}));
			}

			return updated;
		});

		setErrors((prev) => ({ ...prev, [field]: "" }));
	};



	// import { differenceInYears, subYears, parseISO } from 'date-fns';


	const validatePersonalDetailsForm = (form) => {
		const errors = {};

		// Marital Status
		if (!form.maritalStatus) {
			errors.maritalStatus = "Marital Status is required";
		}
		if (form.altEmail) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(form.altEmail)) {
				errors.altEmail = "Invalid alternate email format";
			}
		}
		// Children validation
		if (form.havingChildren?.name === "Yes" && form.noOfChildren?.id) {
			const currentDate = new Date();
			const dateOfMarriage = form.dateOfMarriage ? parseISO(form.dateOfMarriage) : null;
			const yearsSinceMarriage = dateOfMarriage ? differenceInYears(currentDate, dateOfMarriage) : null;
			form.childrenDetails.forEach((child, idx) => {
				const childAge = parseInt(child.age);

				if (!child.gender) {
					errors[`childGender${idx}`] = `Gender for child ${idx + 1} is required`;
				}

				if (!child.age) {
					errors[`childAge${idx}`] = `Age for child ${idx + 1} is required`;
				}
				if (yearsSinceMarriage !== null && childAge > yearsSinceMarriage) {
					errors[`childAge${idx}`] = `Child ${idx + 1}'s age (${childAge}) cannot be more than years since marriage (${yearsSinceMarriage})`;
				}

				if (!child.dependent) {
					errors[`childDependent${idx}`] = `Dependency for child ${idx + 1} is required`;
				}
			});
		}

		// Other required fields
		if (!form.height) {
			errors.height = "Height is required";
		}

		if (!form.motherTongue) {
			errors.motherTongue = "Mother Tongue is required";
		}

		if (!form.healthCondition) {
			errors.healthCondition = "Health Condition is required";
		}

		if (!form.dateOfBirth) {
			errors.dateOfBirth = "Date of Birth is required";
		}

		return errors;
	};

	const [maritalStatusUpload, setMaritalStatusUpload] = useState(null)
	const [uploadedFiles, setUploadedFiles] = useState({
		profilePic: null,
		aadharCard: null,
	});
	const [dateOfBirth, setDateofBirth] = useState()
	const handleUpload = (field, file) => {
		setUploadedFiles((prev) => ({
			...prev,
			[field]: file,
		}));
	};

	const handleUploadForMaritalStatus = (field, file) => {
		setUploadedFiles((prev) => ({
			...prev,
			[field]: file,
		}));
	};


	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState(0);
	const [state, setState] = useState(personalDetailsForm);
	const [religionAndCasteForm, setReligionAndCasteForm] = useState({
		religion: null,
		caste: null,
		subCaste: null,
		convertedCaste: null,
		casteNotAProblem: null,
		gothram: "",
		unclesGothram: "",
		star: null,
		moonsignOrRaasi: null,
		padam: null,
		khujaDhosham: null,
	});
	const [uploadsProofsData, setUploadsProofsData] = useState(
		{
			idProofType: null,
			passportNumber: "",
			panNumber: "",
			name: "",
			surName: "",
			dateOfBirth: "",
			fatherName: "",
			address: ""
		})

	const handleProofDataChange = async (field, value) => {


		setUploadsProofsData((prev) => ({ ...prev, [field]: value }));
		if (field == "idProofType") {
			setUploadsProofsData((prev) => ({ ...prev, ["passportNumber"]: "", ["panNumber"]: "", aadharNumber: "" }));
		}
		setErrors((prev) => ({ ...prev, [field]: "" }));
	};
	const handleReligionCastChange = async (field, value) => {
		if (field == "religion" && value && value?.id) {

			try {
				const response = await fetchCastesByReligionId(value?.id)
				if (response.status) {
					setCastes(response.data);
				}
			} catch (error) {
				console.error("Error fetching castes:", error);
			}
		}

		if (field == "caste" && value && value?.id) {
			await fetchSubCaste(value?.id)
		}
		setReligionAndCasteForm((prev) => ({ ...prev, [field]: value }));
		setErrors((prev) => ({ ...prev, [field]: "" }));
	};
	const [lifeStileAndMaritalStatus, setlifeStileAndMaritalStatus] = useState({
		smoke: null,
		drink: null,
		// food: null,
		hobbies: [],
		interests: [],
		favouriteMusic: [],
		sports: [],
		fitnessActivities: [],
		favouriteCuisine: [],
		favouriteReads: [],
		preferredMovies: [],
		preferredDressStyle: [],
		favouriteFood: [],
		spokenLanguages: [],

	});

	const handleLifeStyleAndMaritalStatus = (field, value) => {
		setlifeStileAndMaritalStatus((prev) => {
			let updated = { ...prev, [field]: value };
			return updated;
		});

		setErrors((prev) => ({ ...prev, [field]: "" }));
	};

	const [contactDetailsForm, setContactDetailsForm] = useState({
		country: null,
		state: null,
		district: null,
		city: null,
		address: "",
		altMobile: "",
		altEmail: "",
		altMobileCountryCode: "+91"

	});
	// const handleContactDetails = async (field, value) => {
	// 	if (field == "country" && value) {
	// 		await fetchStatesListByCountry(value?.id)
	// 	}

	// 	if (field == "state" && value) {
	// 		await fetDistrictsListByState(value?.id)
	// 	}

	// 	if (field == "district" && value) {
	// 		await fetchCitiesListByDistrict(value?.id)
	// 	}
	// 	setContactDetailsForm((prev) => ({ ...prev, [field]: value }));
	// 	setErrors((prev) => ({ ...prev, [field]: "" }));
	// };
	const handleContactDetails = async (field, value) => {
		let updatedFields = { [field]: value };

		if (field === "country") {
			if (value) {
				await fetchStatesListByCountry(value?.id);
			}
			updatedFields = {
				...updatedFields,
				state: null,
				district: null,
				city: null,
			};
		}

		if (field === "state") {
			if (value) {
				await fetDistrictsListByState(value?.id);
			}
			updatedFields = {
				...updatedFields,
				district: null,
				city: null,
			};
		}

		if (field === "district") {
			if (value) {
				await fetchCitiesListByDistrict(value?.id);
			}
			updatedFields = {
				...updatedFields,
				city: null,
			};
		}

		setContactDetailsForm((prev) => ({ ...prev, ...updatedFields }));
		setErrors((prev) => ({ ...prev, [field]: "" }));
	};


	const [applicationInfo, setApplicationInfo] = useState({
		applicationFillingPersonName: "",
		applicationPersonMobileNo: null,
		source: null,
		nearestBranch: null,
		applicationPersonMobileCountryCode: "+91"
	});
	const handleApplicationDetails = (field, value) => {
		setApplicationInfo((prev) => ({ ...prev, [field]: value }));
		setErrors((prev) => ({ ...prev, [field]: "" }));
	};
	const [cities, setCities] = useState([]);
	const [religions, setReligions] = useState([]);
	const [castes, setCastes] = useState([]);
	const [musicList, setMusicList] = useState([]);
	// const [hobbies, setHobbies] = useState([]);
	const [motherTongueList, setMotherTongueList] = useState([]);
	const [starList, setStarList] = useState([]);
	const [moonsignList, setMoonsignList] = useState([]);
	const [alert, setAlert] = useState({
		open: false,
		message: "",
		severity: "success",
	});
	const [interestsList, setInterestsList] = useState([]);
	const [cuisineList, setCuisineList] = useState([]);
	const [readsList, setReadsList] = useState([]);
	const [sportsList, setSportsList] = useState([]);
	const [moviesList, setMoviesList] = useState([]);
	const [dressStyleList, setDressStyleList] = useState([]);
	const [languageList, setLanguageList] = useState([]);
	const [applicationForList, setApplicationForList] = useState([]);
	const [sourceList, setSourceList] = useState([]);
	const [branchList, setBranchList] = useState([]);
	const [healthConditionList, setHealthConditionList] = useState([]);
	const [subCastes, setSubCaste] = useState([]);
	const [contrys, setCountrys] = useState([])
	const [errors, setErrors] = useState({});
	const [motherTongues, setMotherTongue] = useState([])
	// const [subCastes,setSubCastes] = useState([])
	const [birthPlaces, setBirthPlaces] = useState([])
	const [stars, setStars] = useState([])
	const [moonsignsOrRaasis, setMoonsignsOrRaasis] = useState([])
	const [countries, setCountries] = useState([])
	const [states, setStates] = useState([])
	const [districts, setDistricts] = useState([])
	const [contactCities, setContactCities] = useState([])
	const [applicationSources, setSources] = useState([])
	const [branches, setBranches] = useState([])



	const [healthConditions, setHealthConditions] = useState([])
	const apiCall = useRef(false)
	const isClickBack = useRef(false)
	const sections = [
		"Personal Details",
		"Religion & Caste Information",

		"Contact Details",
		"Application Info",
		"Uploads",
		"Life Style"
	];
	const validateReligionAndCasteForm = (form) => {
		const errors = {};

		if (!form.religion) errors.religion = "Religion is required";
		if (!form.caste) errors.caste = "Caste is required";
		return errors
	};

	const validateUploadsData = (form) => {
		const errors = {};
		if (!form.idProofType) errors.idProofType = "Id proof is required";
		if (form.idProofType?.id == "aadharNumber" && !form.aadharNumber) {
			errors.aadharNumber = "Aadahar number is required";
		} else if (form.idProofType?.id == "pan" && !form.panNumber) {
			errors.panNumber = "Pan number proof is required";
		} else if (form.idProofType?.id == "passport" && !form.passportNumber) {
			errors.passportNumber = "passport number is required";

		}
		return errors
	};
	const validateLifestyleAndMaritalStatus = (form) => {
		const errors = {};
		return errors;
	};
	const validateContactDetails = (form) => {
		const errors = {};
		//email validation for alt email 
		if (form.altEmail) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(form.altEmail)) {
				errors.altEmail = "Invalid alternate email format";
			}
		}
		return errors;
	};

	const getLocalMobileNumber = (fullNumber, countryCode) => {
		if (!fullNumber || !countryCode) return "";
		const normalizedCode = countryCode.replace("+", "").trim();

		// If number starts with country code, remove it
		if (fullNumber.startsWith(normalizedCode)) {
			return fullNumber.slice(normalizedCode.length);
		}

		return fullNumber; // fallback if code is not at the start
	};
	const submitContactDetailsInfo = async () => {
		try {

			let payload = {
				countryId: contactDetailsForm.country ? Number(contactDetailsForm.country?.id) : null,
				stateId: contactDetailsForm.state ? Number(contactDetailsForm.state?.id) : null,
				districtId: contactDetailsForm.district ? Number(contactDetailsForm.district?.id) : null,
				cityId: contactDetailsForm.city ? Number(contactDetailsForm.city?.id) : null,
				address: contactDetailsForm.address ? contactDetailsForm.address : null,
				alternateMobile: contactDetailsForm.altMobile ? await getLocalMobileNumber(contactDetailsForm.altMobile, contactDetailsForm.altMobileCountryCode || "+91") : null,
				alternateMobileCountryCode: contactDetailsForm.altMobileCountryCode ? contactDetailsForm.altMobileCountryCode : "+91",
				alternateEmail: contactDetailsForm.altEmail ? contactDetailsForm.altEmail : null

			}
			const response = await updateNewContactDetails(payload);

			if (!response.status) {
				showError(response?.message)
				return false
			}
			showSuccess(response?.message)
			return true

		} catch (e) {
			return false

			console.log("Error....", e)
			setAlert({
				open: true,
				message: e,
				severity: "error",
			});
		}
	}
	const submitPersonalDetails = async () => {
		try {
			let childrensData = []
			if (state?.childrenDetails) {
				state?.childrenDetails.map((each) => {
					let data = {
						"name": "",
						"type": each?.gender ? each?.gender?.name == "Male" ? "son" : "daughter" : "",
						"dependencies": each?.dependent ? each?.dependent?.name : "",
						"age": each?.age ? Number(each?.age) : 0,
						childMaritalStatus: each?.childMaritalStatus ? each?.childMaritalStatus?.name : "Un Married"
					}

					childrensData.push(data)

				})
			}

			let payload = {
				maritalStatus: state?.maritalStatus ? state?.maritalStatus?.id : null,
				dateOfMarriage: state?.dateOfMarriage ? state?.dateOfMarriage : null,
				noofChildren: state?.noOfChildren ? state?.noOfChildren?.id : null,
				havingChildren: state?.havingChildren ? state?.havingChildren?.id : null,
				childrens: state?.childrenDetails ? childrensData : null,
				height: state.height ? state.height?.id : null,
				bloodGroup: state.bloodGroup ? state.bloodGroup?.id : null,
				motherTounge_id: state.motherTongue ? Number(state.motherTongue?.id) : null,
				healthCondition_id: state.healthCondition ? Number(state.healthCondition?.id) : null,
				aboutMe: state.aboutMe ? state.aboutMe : null,
				dateOfBirth: state.dateOfBirth ? state.dateOfBirth : null,
				timeOfBirth: state.timeOfBirth ? state.timeOfBirth : null,
				birthPlace: birthPlace ? birthPlace : null,
				complexion: state.complexion ? state.complexion?.id : null,
				// idProofType : state.idProofType ? state.idProofType?.id : null,
			}
			// if(state?.idProofType && state?.idProofType?.id == "aadharNumber" ){
			// 	payload.idProofNumber = state.aadharNumber ? state.aadharNumber : null

			// }else if(state?.idProofType && state?.idProofType?.id == "pan" ){
			// 	payload.idProofNumber = state.panNumber ? state.panNumber : null

			// }else if(state?.idProofType && state?.idProofType?.id == "passport" ){
			// 	payload.idProofNumber = state.passportNumber ? state.passportNumber : null

			// }
			const response = await updateNewPrsonalDetails(payload);

			if (!response.status) {
				showError(response?.message)
				// setAlert({
				//     open: true,
				//     message: response.message,
				//     severity: "error",
				// });
				return false;
			}

			// setAlert({
			//     open: true,
			//     message: "Personal details updated successfully",
			//     severity: "success",
			// });
			if (state?.maritalStatus?.id != "Single") {
				if (maritalStatusUpload) {
					let formData = new FormData()
					if (state?.maritalStatus?.id == "Divorced") {
						formData.append("divorced", maritalStatusUpload)

					} else if (state?.maritalStatus?.id == "WaitingForDivorce") {
						formData.append("waitingforDivorce", maritalStatusUpload)

					} else if (state?.maritalStatus?.id == "Widowed") {
						formData.append("widower", maritalStatusUpload)

					}
					const data = await personalCertificatesUpload(formData)
					if (!data?.status) {
						showError(data?.message)
					}
				}
			}

			showSuccess(response?.message)

			return true
		} catch (e) {
			return false;
			console.log("Error....", e)
			setAlert({
				open: true,
				message: e,
				severity: "error",
			});
		}
	}
	const submitReligionCastInformation = async () => {
		try {

			let payload = {
				religionId: religionAndCasteForm?.religion ? Number(religionAndCasteForm?.religion?.id) : null,
				casteId: religionAndCasteForm?.caste ? Number(religionAndCasteForm?.caste?.id) : null,
				subCasteId: religionAndCasteForm?.subCaste ? Number(religionAndCasteForm?.subCaste?.id) : null,
				convertedCaste: religionAndCasteForm?.convertedCaste ? Number(religionAndCasteForm?.convertedCaste?.id) : null,
				casteNotProblem: religionAndCasteForm?.casteNotAProblem ? Number(religionAndCasteForm?.casteNotAProblem?.id) : null,
				gothram: religionAndCasteForm?.gothram ? religionAndCasteForm?.gothram : null,
				unclesGothram: religionAndCasteForm?.unclesGothram ? religionAndCasteForm?.unclesGothram : null,
				starId: religionAndCasteForm?.star ? Number(religionAndCasteForm?.star?.id) : null,
				moonsignId: religionAndCasteForm?.moonsignOrRaasi ? Number(religionAndCasteForm?.moonsignOrRaasi?.id) : null,
				padam: religionAndCasteForm?.padam ? Number(religionAndCasteForm?.padam?.id) : null,
				khujaDhosam: religionAndCasteForm?.khujaDhosham || religionAndCasteForm?.khujaDhosham?.id == 0 ? Number(religionAndCasteForm?.khujaDhosham?.id) : null,
			}
			const response = await updateNewCostDetails(payload);

			if (!response.status) {
				showError(response?.message)
				return false;
			}

			// setAlert({
			//     open: true,
			//     message: "Personal details updated successfully",
			//     severity: "success",
			// });
			showSuccess(response?.message)
			return true
		} catch (e) {
			return false;
			console.log("Error....", e)
			setAlert({
				open: true,
				message: e,
				severity: "error",
			});
		}
	}

	const submitLifeStyleAndMaritalInfo = async () => {
		try {
			let payload = {
				smoke: lifeStileAndMaritalStatus?.smoke ? lifeStileAndMaritalStatus?.smoke?.id : null,
				drink: lifeStileAndMaritalStatus?.drink ? lifeStileAndMaritalStatus?.drink?.id : null,
				hobbies: lifeStileAndMaritalStatus?.hobbies?.map((item) => item.id) || [],
				interests: lifeStileAndMaritalStatus?.interests?.map((item) => item.id) || [],
				favouriteMusic: lifeStileAndMaritalStatus?.favouriteMusic?.map((item) => item.id) || [],
				sports: lifeStileAndMaritalStatus?.sports?.map((item) => item.id) || [],
				fitnessActivities: lifeStileAndMaritalStatus?.fitnessActivities?.map((item) => item.id) || [],
				favouriteCuisine: lifeStileAndMaritalStatus?.favouriteCuisine?.map((item) => item.id) || [],
				favouriteReads: lifeStileAndMaritalStatus?.favouriteReads?.map((item) => item.id) || [],
				preferredMovies: lifeStileAndMaritalStatus?.preferredMovies?.map((item) => item.id) || [],
				preferredDressStyle: lifeStileAndMaritalStatus?.preferredDressStyle?.map((item) => item.id) || [],
				favouriteFood: lifeStileAndMaritalStatus?.favouriteFood?.map((item) => item.id) || [],
				spokenLanguages: lifeStileAndMaritalStatus?.spokenLanguages?.map((item) => item.id) || [],
			}
			const response = await updateNewLifeDetails(payload);

			if (!response.status) {
				showError(response?.message)
				return false

			}
			showSuccess(response?.message)
			return true

		} catch (e) {
			return false

			console.log("Error....", e)
			setAlert({
				open: true,
				message: e,
				severity: "error",
			});
		}
	}

	const submitApplicationDetailsInfo = async () => {
		try {

			let payload = {

				"applicationFillingPersonName": applicationInfo?.applicationFillingPersonName ? applicationInfo?.applicationFillingPersonName : null,
				"applicationFillingPersonMobileCountryCode": applicationInfo?.applicationPersonMobileCountryCode ? applicationInfo?.applicationPersonMobileCountryCode : "+91",
				"applicationFillingPersonMobile": applicationInfo?.applicationPersonMobileNo ? await getLocalMobileNumber(applicationInfo.applicationPersonMobileNo, applicationInfo.applicationPersonMobileCountryCode || "+91") : null,
			}

			if (applicationInfo?.source && applicationInfo?.source?.id) {
				payload["sourceId"] = applicationInfo?.source ? Number(applicationInfo?.source?.id) : null
			}
			if (applicationInfo?.nearestBranch && applicationInfo?.nearestBranch?.id) {
				payload["branchId"] = applicationInfo?.nearestBranch ? Number(applicationInfo?.nearestBranch?.id) : null
			}
			const response = await updateNewCApplicationDetails(payload);

			if (!response.status) {

				showError(response.message)
				return false;
			}

			showSuccess(response.message)
			return true
		} catch (e) {
			return false
			console.log("Error....", e)
			setAlert({
				open: true,
				message: e,
				severity: "error",
			});
		}
	}

	const handleNext = async () => {
		let isValid = true;
		apiCall.current = false
		isClickBack.current = false


		if (activeTab === 0) {
			const validationErrors = validatePersonalDetailsForm(state);

			if (Object.keys(validationErrors).length === 0) {

				let submitResponse = await submitPersonalDetails()
				if (!submitResponse) {
					isValid = false
				}
			} else {
				isValid = false
				setErrors(validationErrors)
			}

		} else if (activeTab === 1) {

			const validationErrors = validateReligionAndCasteForm(religionAndCasteForm);

			if (Object.keys(validationErrors).length === 0) {

				let submitResponse = await submitReligionCastInformation()
				if (!submitResponse) {
					isValid = false
				}
			} else {
				isValid = false
				setErrors(validationErrors)
			}
		} else if (activeTab === 2) {
			const validationErrors = validateContactDetails(contactDetailsForm);

			if (Object.keys(validationErrors).length === 0) {

				let submitResponse = await submitContactDetailsInfo()
				if (!submitResponse) {
					isValid = false
				}
			} else {
				isValid = false
				setErrors(validationErrors)
			}

		} else if (activeTab === 3) {
			let submitResponse = await submitApplicationDetailsInfo()
			if (!submitResponse) {
				isValid = false
			}
		} else if (activeTab == 4) {
			const validationErrors = validateUploadsData(uploadsProofsData);
			if (Object.keys(validationErrors).length === 0) {


				if (uploadsProofsData.aadharNumber || uploadsProofsData.panNumber || uploadsProofsData.passportNumber) {

					let payload = {
						idProofType: uploadsProofsData.idProofType ? uploadsProofsData.idProofType?.id : null,
					}


					if (uploadsProofsData?.idProofType && uploadsProofsData?.idProofType?.id == "aadharNumber") {
						payload.idProofNumber = uploadsProofsData.aadharNumber ? uploadsProofsData.aadharNumber : null

					} else if (uploadsProofsData?.idProofType && uploadsProofsData?.idProofType?.id == "pan") {
						payload.idProofNumber = uploadsProofsData.panNumber ? uploadsProofsData.panNumber : null

					} else if (uploadsProofsData?.idProofType && uploadsProofsData?.idProofType?.id == "passport") {
						payload.idProofNumber = uploadsProofsData.passportNumber ? uploadsProofsData.passportNumber : null

					}

					const response = await updateNewPrsonalDetails(payload);
					if (!response?.status) {
						showError(response?.message)
						isValid = false
					}

				}
				if (uploadedFiles?.profilePic) {
					const formData = new FormData()
					formData?.append("profileImage", uploadedFiles?.profilePic)
					let profileResponse = await uploadProfilePic(formData)
					if (!profileResponse?.status) {
						showError(profileResponse?.message)
						isValid = false
					}
				}
				if (uploadedFiles?.aadharCard) {
					const formData = new FormData()
					formData?.append("idImage", uploadedFiles?.aadharCard)
					formData?.append("idType", state?.idProofType?.id)
					let uploadIdResponse = await uploadIdProof(formData)
					if (!uploadIdResponse?.status) {
						showError(uploadIdResponse?.message)
						isValid = false
					}
				}
			} else {
				isValid = false
				setErrors(validationErrors)
			}
		}
		if (isValid && activeTab === sections.length - 1) {

			const validationErrors = validateLifestyleAndMaritalStatus(lifeStileAndMaritalStatus);

			if (Object.keys(validationErrors).length === 0) {

				let submitResponse = await submitLifeStyleAndMaritalInfo()
				if (!submitResponse) {
					isValid = false
				}
			} else {
				isValid = false
				setErrors(validationErrors)
			}
			if (isValid) {
				if (type != "edit") {
					navigate("/profile/education"); // Change to your desired path
				} else {
					onSubmitSuccess?.();
				}
			}
		} else if (isValid) {
			setActiveTab((prev) => prev + 1);
		}
		// if (isValid && activeTab < sections.length - 1) {
		// 	setActiveTab((prev) => prev + 1);
		// }
	};
	const handleBack = () => {
		if (activeTab > 0) {
			isClickBack.current = true
			apiCall.current = false
			setActiveTab((prev) => prev - 1);
		}
	};
	const fetchMotherTongue = async () => {
		try {
			const response = await getMotherTongueList();
			if (response.status) {
				setMotherTongue(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchHelthCondtions = async () => {
		try {
			const response = await getHealthConditionList()
			if (response.status) {
				setHealthConditions(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchCities = async () => {
		try {
			const response = await getCitiesList()
			if (response.status) {
				setBirthPlaces(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchReligions = async () => {
		try {
			const response = await getReligionsList()
			if (response.status) {
				setReligions(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchSubCaste = async (id) => {
		try {
			const response = await getSubCatesList(id);
			if (response.status) {
				setSubCaste(response.data);
			} else {
				setSubCaste([]);
			}
		} catch (error) {
			console.error("Error fetching subcastes:", error);

		}
	};
	const fetchCasteList = async (id) => {
		try {
			const response = await getCastesList();
			if (response.status) {
				setCastes(response.data);
			} else {
				setCastes([]);
			}
		} catch (error) {
			console.error("Error fetching subcastes:", error);

		}
	};
	const fetchStarsList = async () => {
		try {
			const response = await getStarList()
			if (response.status) {
				setStars(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchRaasi = async () => {
		try {
			const response = await getMoonsignList()
			if (response.status) {
				setMoonsignsOrRaasis(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchCountriesList = async () => {
		try {
			const response = await getCountriesList()
			if (response.status) {
				setCountries(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchStatesListByCountry = async (id) => {
		try {
			const response = await getStatesListByCountry(id)
			if (response.status) {
				setStates(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetDistrictsListByState = async (id) => {
		try {
			const response = await getDistrictsListByState(id)
			if (response.status) {
				setDistricts(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchCitiesListByDistrict = async (id) => {
		try {
			const response = await getCitiessListByDistrict(id)
			if (response.status) {
				setContactCities(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchSourceList = async () => {
		try {
			const response = await getSourceList()
			if (response.status) {
				setSources(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};
	const fetchNearestBranchList = async () => {
		try {
			const response = await nearestBranch()
			if (response.status) {
				setBranches(response.data);
			}
		} catch (error) {
			console.error("Error fetching castes:", error);
		}
	};

	const getFullMobileNumber = (mobileNumber, countryCode) => {
		if (!mobileNumber || !countryCode) return "";

		const normalizedCode = countryCode.replace("+", "").trim();
		const normalizedNumber = mobileNumber.replace(/^0+/, ""); // Remove leading zeros

		return normalizedCode + normalizedNumber;
	};
	useEffect(() => {
		const fetchProfileDetials = async () => {
			try {
				const response = await getProfileDetails();
				if (response?.status) {
					let checkTabs = false;
					setProfileStrength(response?.profileStrenth || 0);

					const personalDetailsData = response?.data?.customerPersonalDetails;
					const religionDetails = response?.data?.customerCastDetails;
					const previousContactDetails = response?.data?.customerContactDetails;
					const previousApplicationDetails = response?.data?.customerApplicationDetails;
					const lifeStyleDetails = response?.data?.customerLifeDetails;

					// Profile Picture and ID Proof setup
					setPreviousProfilePic(response?.data?.profilePicture || null);
					setPreviousAadharCard(response?.data?.idProofPicture || null);

					// Skip logic if editing or going back
					if (type !== "edit" && !isClickBack.current && response?.profileStrenth >= 60) {
						if (
							!personalDetailsData?.dateOfMarriage ||
							!personalDetailsData?.maritalStatus ||
							!personalDetailsData?.height ||
							!personalDetailsData?.bloodGroup ||
							!personalDetailsData?.motherTongue ||
							!personalDetailsData?.healthCondition ||
							!personalDetailsData?.aboutMe ||
							!personalDetailsData?.dateOfBirth ||
							!personalDetailsData?.timeOfBirth ||
							!personalDetailsData?.birthPlace
						) {
							setActiveTab(0);
							checkTabs = true;
						} else if (
							!religionDetails?.religion ||
							!religionDetails?.caste ||
							!religionDetails?.gothram ||
							!religionDetails?.star ||
							!religionDetails?.moonsign ||
							!religionDetails?.padam ||
							(!religionDetails?.khujaDhosam && religionDetails?.khujaDhosam != 0)
						) {
							setActiveTab(1);
							checkTabs = true;
						} else if (
							!previousContactDetails?.country ||
							!previousContactDetails?.state ||
							!previousContactDetails?.district ||
							!previousContactDetails?.city ||
							!previousContactDetails?.address ||
							!previousContactDetails?.alternateMobile ||
							!previousContactDetails?.alternateMobileCountryCode ||
							!previousContactDetails?.alternateEmail
						) {
							setActiveTab(2);
							checkTabs = true;
						} else if (
							!previousApplicationDetails?.applicationFillingPersonName ||
							!previousApplicationDetails?.applicationFillingPersonMobile ||
							!previousApplicationDetails?.applicationFillingPersonMobileCountryCode ||
							!previousApplicationDetails?.source ||
							!previousApplicationDetails?.nearestBranch
						) {
							setActiveTab(3);
							checkTabs = true;
						} else if (
							!response?.data?.profilePicture ||
							!response?.data?.idProofPicture
						) {
							setActiveTab(4);
							checkTabs = true;
						} else if (
							!lifeStyleDetails?.smoke ||
							!lifeStyleDetails?.drink ||
							!lifeStyleDetails?.hobbies ||
							!lifeStyleDetails?.interests ||
							!lifeStyleDetails?.favouriteMusic ||
							!lifeStyleDetails?.sports ||
							!lifeStyleDetails?.fitnessActivities ||
							!lifeStyleDetails?.favouriteCuisine ||
							!lifeStyleDetails?.favouriteReads ||
							!lifeStyleDetails?.preferredMovies ||
							!lifeStyleDetails?.preferredDressStyle ||
							!lifeStyleDetails?.favouriteFood ||
							!lifeStyleDetails?.spokenLanguages
						) {
							setActiveTab(5); // if you have a lifestyle tab
							checkTabs = true;
						}
					}

					// If everything is filled and we're not editing or clicking back, go to education
					if (!checkTabs && type !== "edit" && !isClickBack.current && response?.profileStrenth >= 65) {
						navigate("/profile/education");
					}
					if (activeTab == 0) {
						let previousChildrens = []
						if (response?.data?.children.length > 0) {
							response?.data?.children.map((each) => {
								let object = {
									gender: each?.type == "son" ? { id: "Male", name: "Male" } : { id: "Female", name: "Female" },
									dependent: each.dependencies ? [
										{ id: "Father", name: "Father" },
										{ id: "Mother", name: "Mother" },
										{ id: "Both", name: "Both" },
										{ id: "Independent", name: "Independent" },
									].find((dep) => dep?.id == each.dependencies) : "",
									childMaritalStatus: each.childMaritalStatus ? [
										{ id: "married", name: "Married" },
										{ id: "unMarried", name: "Un Married" },
									].find((dep) => dep?.name == each.childMaritalStatus) : "",
									age: each.age,
								}
								previousChildrens.push(object)
							})

						}
						const updatedState = {
							...state,
							dateOfMarriage: personalDetailsData?.dateOfMarriage
								? personalDetailsData?.dateOfMarriage
								: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),

							maritalStatus: personalDetailsData?.maritalStatus
								? personalDetailsData?.maritalStatus === "Single"
									? { id: "Single", name: "Un Married" }
									: { id: personalDetailsData?.maritalStatus, name: personalDetailsData?.maritalStatus }
								: null,

							noOfChildren: personalDetailsData?.noofChildren
								? { id: personalDetailsData?.noofChildren, name: personalDetailsData?.noofChildren }
								: null,


							havingChildren: personalDetailsData?.havingChildren
								? { id: personalDetailsData?.havingChildren, name: "Yes" }
								: { id: personalDetailsData?.havingChildren, name: "No" },
							childrenDetails: response?.data?.children.length > 0 ? previousChildrens : [],
							aadharNumber: personalDetailsData?.aadharNumber ? personalDetailsData?.aadharNumber : "",
							height: personalDetailsData?.height
								? heightOptions.find((each) => each?.id == personalDetailsData?.height)
								: null,
							bloodGroup: personalDetailsData?.bloodGroup
								? bloodGroups.find((each) => each?.id == personalDetailsData?.bloodGroup)
								: null,
							motherTongue: personalDetailsData?.motherTongue
								? { id: personalDetailsData?.motherTongue?.id, name: personalDetailsData?.motherTongue?.name }
								: null,
							healthCondition: personalDetailsData?.healthCondition
								? { id: personalDetailsData?.healthCondition?.id, name: personalDetailsData?.healthCondition?.name }
								: null,
							aboutMe: personalDetailsData?.aboutMe ? personalDetailsData?.aboutMe : "",
							dateOfBirth: personalDetailsData?.dateOfBirth
								? personalDetailsData?.dateOfBirth
								: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
							timeOfBirth: personalDetailsData?.timeOfBirth ? personalDetailsData?.timeOfBirth : dayjs(),
							complexion: personalDetailsData?.complexion ? complexions.find((each) => each?.id == personalDetailsData?.complexion) : null,
						};
						setState(updatedState);
						setBirthPlace(personalDetailsData?.birthPlace || "");
						let updateIdProofsData = {
							...uploadsProofsData,
							idProofType: response?.data?.idProofType ? idProofTypes.find((each) => each.id == response?.data?.idProofType) : null,
							aadharNumber: response?.data?.idProofNumber ? response?.data?.idProofNumber : null,
							panNumber: response?.data?.idProofNumber ? response?.data?.idProofNumber : null,
							passportNumber: response?.data?.idProofNumber ? response?.data?.idProofNumber : null
						}
						setUploadsProofsData(updateIdProofsData)

					} else if (activeTab == 1) {
						let religionDetails = response?.data?.customerCastDetails
						const updateReligionAndCaste = {
							...religionAndCasteForm,
							religion: religionDetails?.religion ? { id: religionDetails?.religion?.id, religionName: religionDetails?.religion?.religionName } : null,
							caste: religionDetails?.caste ? { id: religionDetails?.caste?.id, castName: religionDetails?.caste?.castName } : null,
							subCaste: religionDetails?.subCaste ? { id: religionDetails?.subCaste?.id, castName: religionDetails?.subCaste?.castName } : null,
							gothram: religionDetails?.gothram ? religionDetails.gothram : "",
							unclesGothram: religionDetails?.unclesGothram ? religionDetails.unclesGothram : "",
							star: religionDetails?.star ? { id: religionDetails?.star?.id, name: religionDetails?.star?.name } : null,
							moonsignOrRaasi: religionDetails?.moonsign ? { id: religionDetails?.moonsign?.id, name: religionDetails?.moonsign?.name } : null,
							padam: religionDetails?.padam ? padams.find((each) => each?.id == religionDetails?.padam) : null,
							khujaDhosham: religionDetails?.khujaDhosam || religionDetails?.khujaDhosam == 0 ? khujaDhoshamOptions.find((each) => each?.id == religionDetails.khujaDhosam) : null,
						}
						setReligionAndCasteForm(updateReligionAndCaste)

					} else if (activeTab == 2) {
						const previousContactDetails = response?.data?.customerContactDetails

						setContactDetailsForm({
							...contactDetailsForm,
							country: previousContactDetails?.country ? { id: previousContactDetails.country?.id, countryName: previousContactDetails.country?.countryName } : null,
							state: previousContactDetails?.state ? { id: previousContactDetails.state?.id, stateName: previousContactDetails.state?.stateName } : null,
							district: previousContactDetails?.district ? { id: previousContactDetails.district?.id, districtName: previousContactDetails.district?.districtName } : null,
							city: previousContactDetails?.city ? { id: previousContactDetails.city?.id, cityName: previousContactDetails.city?.cityName } : null,
							address: previousContactDetails?.address ? previousContactDetails.address : "",
							altMobile: getFullMobileNumber(previousContactDetails.alternateMobile, previousContactDetails?.alternateMobileCountryCode) || "",
							altEmail: previousContactDetails?.alternateEmail ? previousContactDetails.alternateEmail : "",
							altMobileCountryCode: previousContactDetails?.alternateMobileCountryCode ? previousContactDetails.alternateMobileCountryCode : "+91"

						});
					} else if (activeTab == 3) {

						const previousApplicationDetails = response?.data?.customerApplicationDetails

						setApplicationInfo({
							...applicationInfo,
							applicationFillingPersonName: previousApplicationDetails?.applicationFillingPersonName ? previousApplicationDetails?.applicationFillingPersonName : "",
							applicationPersonMobileNo: getFullMobileNumber(previousApplicationDetails.applicationFillingPersonMobile, previousApplicationDetails?.applicationFillingPersonMobileCountryCode) || "",
							source: previousApplicationDetails?.source ? { id: previousApplicationDetails.source?.id, sourceName: previousApplicationDetails.source?.sourceName } : null,
							nearestBranch: previousApplicationDetails?.nearestBranch ? { id: previousApplicationDetails.nearestBranch?.id, name: previousApplicationDetails.nearestBranch?.branchName } : null,
							applicationPersonMobileCountryCode: previousApplicationDetails?.applicationFillingPersonMobileCountryCode ? previousApplicationDetails.applicationFillingPersonMobileCountryCode : "+91"
						});
					} else if (activeTab == 4) {
						setPreviousProfilePic(response?.data ? response?.data?.profilePicture : null)
						setPreviousAadharCard(response?.data ? response?.data?.idProofPicture : null)
					} else if (activeTab == 5) {
						const lifeStyleDetails = response?.data?.customerLifeDetails

						setlifeStileAndMaritalStatus({
							...lifeStileAndMaritalStatus,
							smoke: lifeStyleDetails.smoke ? { id: lifeStyleDetails.smoke, name: lifeStyleDetails.smoke } : null,
							drink: lifeStyleDetails.drink ? { id: lifeStyleDetails.drink, name: lifeStyleDetails.drink } : null,
							hobbies: lifeStyleDetails?.hobbies ? hobbies.filter(hobby => lifeStyleDetails?.hobbies.includes(hobby.name)) : [],
							interests: lifeStyleDetails?.interests ? interests.filter(hobby => lifeStyleDetails?.interests.includes(hobby.name)) : [],
							favouriteMusic: lifeStyleDetails?.favouriteMusic ? favouriteMusic.filter(hobby => lifeStyleDetails?.favouriteMusic.includes(hobby.name)) : [],
							sports: lifeStyleDetails?.sports ? sports.filter(hobby => lifeStyleDetails?.sports.includes(hobby.name)) : [],
							fitnessActivities: lifeStyleDetails?.fitnessActivities ? fitnessActivities.filter(hobby => lifeStyleDetails?.fitnessActivities.includes(hobby.name)) : [],
							favouriteCuisine: lifeStyleDetails?.favouriteCuisine ? favouriteCuisine.filter(hobby => lifeStyleDetails?.favouriteCuisine.includes(hobby.name)) : [],
							favouriteReads: lifeStyleDetails?.favouriteReads ? favouriteReads.filter(hobby => lifeStyleDetails?.favouriteReads.includes(hobby.name)) : [],
							preferredMovies: lifeStyleDetails?.preferredMovies ? preferredMovies.filter(hobby => lifeStyleDetails?.preferredMovies.includes(hobby.name)) : [],
							preferredDressStyle: lifeStyleDetails?.preferredDressStyle ? preferredDressStyle.filter(hobby => lifeStyleDetails?.preferredDressStyle.includes(hobby.name)) : [],
							favouriteFood: lifeStyleDetails?.favouriteFood ? favouriteFood.filter(hobby => lifeStyleDetails?.favouriteFood.includes(hobby.name)) : [],
							spokenLanguages: lifeStyleDetails?.spokenLanguages ? spokenLanguages.filter(hobby => lifeStyleDetails?.spokenLanguages.includes(hobby.name)) : [],
						}
						)


					}
				}
			} catch (e) {
				console.log("Error........", e)
			}
		}
		fetchProfileDetials()
	}, [activeTab, type])
	useEffect(() => {
		const fetDataFromApis = async () => {
			if (!apiCall.current && activeTab == 0) {
				apiCall.current = true
				await fetchMotherTongue()
				await fetchHelthCondtions()
				await fetchCities()
			} else if (!apiCall.current && activeTab == 1) {
				apiCall.current = true
				await fetchReligions()
				await fetchCasteList()
				await fetchStarsList()
				await fetchRaasi()
			} else if (!apiCall.current && activeTab == 2) {
				apiCall.current = true
				await fetchCountriesList()
			} else if (!apiCall.current && activeTab == 3) {
				apiCall.current = true
				await fetchSourceList()
				await fetchNearestBranchList()
			}
		}

		fetDataFromApis()

	}, [activeTab, type])


	const renderTabContent = () => {
		switch (activeTab) {
			case 0:
				return (
					<>
						<Grid container xs={12} spacing={2}>


							<Grid item xs={12} sm={4}>
								{/* <Autocomplete
									options={maritalStatuses}
									getOptionLabel={(option) => option.name}
									value={state.maritalStatus}
									onChange={(e, newValue) => handleChange("maritalStatus", newValue)}
									// disabled={
									// 	type !== "edit" || 
									// 	!state.maritalStatus || 
									// 	!state.maritalStatus.hasmaritalStatus 
									//   }
								renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Marital Status (2)"
											variant="outlined"
											size="small"
											error={!!errors.maritalStatus}
											helperText={errors.maritalStatus}
										/>
									)}
								/> */}
								<Autocomplete
									options={maritalStatuses}
									getOptionLabel={(option) => option.name}
									value={state.maritalStatus}
									onChange={(e, newValue) => handleChange("maritalStatus", newValue)}
									disabled={Boolean(state.maritalStatus) && type === "edit"}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Marital Status (2)"
											variant="outlined"
											size="small"
											error={!!errors.maritalStatus}
											helperText={errors.maritalStatus}
										/>
									)}
								/>

							</Grid>


							{state.maritalStatus && state.maritalStatus?.id != "Single" && (
								<>
									<Grid item xs={12} sm={4}>
										<Autocomplete
											options={havingChildrens}
											getOptionLabel={(option) => option.name}
											value={state.havingChildren}
											onChange={(e, newValue) => handleChange("havingChildren", newValue)}
											renderInput={(params) => (
												<StyledTextField
													{...params}
													label="Having Children?"
													variant="outlined"
													size="small"
												/>
											)}
										/>
									</Grid>
									{state.havingChildren && state.havingChildren?.name == "Yes" && <>
										<Grid item xs={12} sm={4}>
											<Autocomplete
												options={noOfChildrens}
												getOptionLabel={(option) => option.name}
												value={state.noOfChildren}
												onChange={(e, newValue) => handleChange("noOfChildren", newValue)}
												renderInput={(params) => (
													<StyledTextField
														{...params}
														label="No of Childrens?"
														variant="outlined"
														size="small"
													/>
												)}
											/>
										</Grid>
										<Grid item xs={12} sm={4}> </Grid></>}
									{state.havingChildren?.name === "Yes" &&
										state.noOfChildren?.id &&
										state.childrenDetails.map((child, index) => (
											<Grid container xs={12} spacing={2} style={{ margin: 0 }}>
												<React.Fragment key={index}>

													<Grid item xs={12} sm={parseInt(child.age) >= 18 ? 3 : 4}>
														<Autocomplete
															options={[{ id: 1, name: "Male" }, { id: 2, name: "Female" }]}
															getOptionLabel={(option) => option.name}
															value={child.gender}
															onChange={(e, newValue) => {
																const updatedChildren = [...state.childrenDetails];
																updatedChildren[index].gender = newValue;
																setState({ ...state, childrenDetails: updatedChildren });
															}}
															renderInput={(params) => (
																<StyledTextField {...params} label={`Child ${index + 1} Gender`} size="small" />
															)}
														/>
													</Grid>

													<Grid item xs={12} sm={parseInt(child.age) >= 18 ? 3 : 4}>
														<StyledTextField
															fullWidth
															label={`Child ${index + 1} Age`}
															type="number"
															value={child.age}
															onChange={(e) => {
																const updatedChildren = [...state.childrenDetails];
																updatedChildren[index].age = e.target.value;
																setState({ ...state, childrenDetails: updatedChildren });
															}}
															size="small"
															error={!!errors?.[`childAge${index}`]} // 👈 Highlights the field
															helperText={errors?.[`childAge${index}`]} // 👈 Shows error below the field
														/>
													</Grid>
													{((child.gender?.name === "Male" && parseInt(child.age) >= 21) ||
														(child.gender?.name === "Female" && parseInt(child.age) >= 18))
														&& <Grid item xs={12} sm={parseInt(child.age) >= 18 ? 3 : 4}>
															<Autocomplete
																options={[
																	{ id: "married", name: "Married" },
																	{ id: "unMarried", name: "Un Married" },
																]}
																getOptionLabel={(option) => option.name}
																value={child.childMaritalStatus}
																onChange={(e, newValue) => {
																	const updatedChildren = [...state.childrenDetails];
																	updatedChildren[index].childMaritalStatus = newValue;
																	setState({ ...state, childrenDetails: updatedChildren });
																}}
																renderInput={(params) => (
																	<StyledTextField {...params} label={`Child ${index + 1} Marital Status?`} size="small" />
																)}
															/>
														</Grid>}
													<Grid item xs={12} sm={parseInt(child.age) >= 18 ? 3 : 4}>
														<Autocomplete
															options={[
																{ id: "Father", name: "Father" },
																{ id: "Mother", name: "Mother" },
																{ id: "Both", name: "Both" },
																{ id: "Independent", name: "Independent" },
															]}
															getOptionLabel={(option) => option.name}
															value={child.dependent}
															onChange={(e, newValue) => {
																const updatedChildren = [...state.childrenDetails];
																updatedChildren[index].dependent = newValue;
																setState({ ...state, childrenDetails: updatedChildren });
															}}
															renderInput={(params) => (
																<StyledTextField {...params} label={`Child ${index + 1} Dependent?`} size="small" />
															)}
														/>
													</Grid>

												</React.Fragment>
											</Grid>
										))
									}

									<Grid item xs={12} sm={state.noOfChildren?.id ? 4 : 4}>
										<StyledTextField
											fullWidth
											label="Date Of Marriage"
											type="date"
											value={state.dateOfMarriage ? new Date(state.dateOfMarriage).toISOString().slice(0, 10) : ""}
											onChange={(e) => handleChange("dateOfMarriage", e.target.value)}
											size="small"
											error={!!errors.dateOfMarriage}
											helperText={errors.dateOfMarriage}
											inputProps={{
												max: new Date(new Date().setFullYear(new Date().getFullYear() - 18))
													.toISOString()
													.slice(0, 10),
											}}
										/>
									</Grid>
								</>
							)}


							<Grid item xs={12} sm={4}>
								{/* <StyledTextField
									fullWidth
									label="Height (in cm)"
									value={state.height}
									onChange={(e) => handleChange("height", e.target.value)}
									size="small"
									error={!!errors.height}
									helperText={errors.height}
								/> */}

								<Autocomplete
									options={heightOptions}
									getOptionLabel={(option) => option.name}
									value={state.height}
									onChange={(e, newValue) => handleChange("height", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Height (1)"
											variant="outlined"
											size="small"
											error={!!errors.height}
											helperText={errors.height}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<Autocomplete
									options={bloodGroups}
									getOptionLabel={(option) => option.name}
									value={state.bloodGroup}
									onChange={(e, newValue) => handleChange("bloodGroup", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Blood Group"
											variant="outlined"
											size="small"
											error={!!errors.bloodGroup}
											helperText={errors.bloodGroup}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<Autocomplete
									options={motherTongues}
									getOptionLabel={(option) => option.name}
									value={state.motherTongue}
									onChange={(e, newValue) => handleChange("motherTongue", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Mother Tongue"
											variant="outlined"
											size="small"
											error={!!errors.motherTongue}
											helperText={errors.motherTongue}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<Autocomplete
									options={healthConditions}
									getOptionLabel={(option) => option.name}
									value={state.healthCondition}
									onChange={(e, newValue) => handleChange("healthCondition", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Health Condition"
											variant="outlined"
											size="small"
											error={!!errors.healthCondition}
											helperText={errors.healthCondition}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Autocomplete
									options={complexions}
									getOptionLabel={(option) => option.name}
									value={state.complexion}
									onChange={(e, newValue) => handleChange("complexion", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Complexion"
											variant="outlined"
											size="small"
											error={!!errors.complexion}
											helperText={errors.complexion}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<StyledTextField
									fullWidth
									label="Date Of Birth (2)"
									type="date"
									value={state.dateOfBirth ? new Date(state.dateOfBirth).toISOString().slice(0, 10) : ""}
									onChange={(e) => handleChange("dateOfBirth", e.target.value)}
									// disabled={
									// 	type !== "edit" || 
									// 	!state.dateOfBirth || 
									// 	!state.dateOfBirth.hasdateOfBirth 
									//   }
									size="small"
									error={!!errors.dateOfBirth}

									helperText={errors.dateOfBirth}
									inputProps={{
										max: new Date(new Date().setFullYear(new Date().getFullYear() - 18))
											.toISOString()
											.slice(0, 10),
									}}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<StyledTextField
									fullWidth
									label="Time Of Birth"
									type="time"
									value={state.timeOfBirth}
									onChange={(e) => handleChange("timeOfBirth", e.target.value)}
									size="small"
									error={!!errors.timeOfBirth}
									helperText={errors.timeOfBirth}
								/>
							</Grid>

							{/* <Grid item xs={12} sm={4}>
								<Autocomplete
									options={birthPlaces}
									getOptionLabel={(option) => option.cityName}
									value={state.birthPlace}
									onChange={(e, newValue) => handleChange("birthPlace", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Birth Place"
											variant="outlined"
											size="small"
											error={!!errors.birthPlace}
											helperText={errors.birthPlace}
										/>
									)}
								/>
							</Grid> */}

							<Grid item xs={12} sm={4}>
								<StyledTextField
									fullWidth
									label="Birth Place"
									value={birthPlace}
									onChange={(e) => setBirthPlace(e.target.value)}
									variant="outlined"
									size="small"
									error={!!errors.birthPlace}
									helperText={errors.birthPlace}
								/>
							</Grid>
							<Grid item xs={12}>
								<StyledTextField
									fullWidth
									label="About Me (3)"
									multiline
									rows={3}
									value={state.aboutMe}
									onChange={(e) => handleChange("aboutMe", e.target.value)}
									size="small"
									error={!!errors.aboutMe}
									helperText={errors.aboutMe}
								/>
							</Grid>
							{state.maritalStatus && state.maritalStatus?.id != "Single" && <Grid item xs={4} sm={4}></Grid>}
							{state.maritalStatus && state.maritalStatus?.id != "Single" && <Grid item xs={4} sm={4}>
								<Box display="flex" flexDirection="column" alignItems="center">
									<Typography variant="subtitle1" gutterBottom>
										Upload {(state.maritalStatus?.id == "Widowed" || state.maritalStatus?.id == "WaitingForDivorce") ? state.maritalStatus?.id == "Widowed" ? "Death" : "Acknowledgement" : state.maritalStatus?.id} Certificate
									</Typography>
									<Button variant="contained" component="label"
									>
										Choose File
										<input
											hidden
											accept="image/*"
											type="file"
											onChange={(e) => {
												const file = e.target.files[0];
												if (file) setMaritalStatusUpload(file);
											}}
										/>
									</Button>
									{maritalStatusUpload && (
										<Box mt={2}>
											{/* <Typography variant="caption">Preview:</Typography> */}
											<img
												src={URL.createObjectURL(maritalStatusUpload)}
												alt="Profile Preview"
												style={{
													width: "150px",
													height: "150px",
													objectFit: "cover",
													borderRadius: "8px",
													marginTop: "8px",
												}}
											/>
										</Box>
									)}
								</Box>
							</Grid>}
						</Grid>
					</>

				);
			case 1:
				return (
					<>
						<Grid container xs={12} spacing={2}>
							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={religions}
									getOptionLabel={(option) => option.religionName}
									value={religionAndCasteForm.religion}
									onChange={(e, newValue) => handleReligionCastChange("religion", newValue)}
									// disabled={
									// 	type !== "edit"
									// 	 || 
									// 	!religionAndCasteForm.religion || 
									// 	!religionAndCasteForm.religion.hasCastes
									//   }
									disabled={Boolean(religionAndCasteForm.religion) && type === "edit"}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Religion (2)"
											variant="outlined"
											size="small"
											error={!!errors.religion}
											helperText={errors.religion}
										/>
									)}
								/>
							</Grid>

							{/* <Grid item xs={12} sm={6}>
								<Autocomplete
									options={castes}
									getOptionLabel={(option) => option.castName}
									value={religionAndCasteForm.caste}
									onChange={(e, newValue) => handleReligionCastChange("caste", newValue)}
									disabled={type !== "edit"}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Caste"
											variant="outlined"
											size="small"
											error={!!errors.caste}
											helperText={errors.caste}
										/>
									)}
								/>
							</Grid> */}
							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={castes}
									getOptionLabel={(option) => option.castName}
									value={religionAndCasteForm.caste}
									onChange={(e, newValue) => handleReligionCastChange("caste", newValue)}
									// disabled={
									//   type !== "edit"
									//    || 
									//   !religionAndCasteForm.religion || 
									//   !religionAndCasteForm.religion.hasCastes
									// }
									disabled={Boolean(religionAndCasteForm.caste) && type === "edit"}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Caste (2)"
											variant="outlined"
											size="small"
											error={!!errors.caste}
											helperText={errors.caste}
										/>
									)}
								/>
							</Grid>
							{(subCastes.length > 0 || religionAndCasteForm.subCaste) && <Grid item xs={12} sm={6}>
								<Autocomplete
									options={subCastes}
									getOptionLabel={(option) => option.castName}
									value={religionAndCasteForm.subCaste}
									onChange={(e, newValue) => handleReligionCastChange("subCaste", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Sub Caste"
											variant="outlined"
											size="small"
											error={!!errors.subCaste}
											helperText={errors.subCaste}
										/>
									)}
								/>
							</Grid>}

							{/* <Grid item xs={12} sm={6}>
								<Autocomplete
									options={convertedCastes}
									getOptionLabel={(option) => option.name}
									value={religionAndCasteForm.convertedCaste}
									onChange={(e, newValue) => handleReligionCastChange("convertedCaste", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Converted Caste"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid> */}

							{/* <Grid item xs={12} sm={6}>
								<Autocomplete
									options={casteNotAProblemOptions}
									getOptionLabel={(option) => option.name}
									value={religionAndCasteForm.casteNotAProblem}
									onChange={(e, newValue) => handleReligionCastChange("casteNotAProblem", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Caste Not a Problem"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid> */}

							<Grid item xs={12} sm={6}>
								<StyledTextField
									fullWidth
									label="Gothram (1)"
									value={religionAndCasteForm.gothram}
									onChange={(e) => handleReligionCastChange("gothram", e.target.value)}
									size="small"
									error={!!errors.gothram}
									helperText={errors.gothram}
								/>
							</Grid>

							{(religionAndCasteForm?.caste && religionAndCasteForm?.caste?.castName == "Arya Vyshya") && <Grid item xs={12} sm={6}>
								<StyledTextField
									fullWidth
									label="Uncle's Gothram"
									value={religionAndCasteForm.unclesGothram}
									onChange={(e) => handleReligionCastChange("unclesGothram", e.target.value)}
									size="small"
								/>
							</Grid>}

							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={stars}
									getOptionLabel={(option) => option.name}
									value={religionAndCasteForm.star}
									onChange={(e, newValue) => handleReligionCastChange("star", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Star (1)"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={moonsignsOrRaasis}
									getOptionLabel={(option) => option.name}
									value={religionAndCasteForm.moonsignOrRaasi}
									onChange={(e, newValue) => handleReligionCastChange("moonsignOrRaasi", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Moonsign / Raasi"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={padams}
									getOptionLabel={(option) => option.name}
									value={religionAndCasteForm.padam}
									onChange={(e, newValue) => handleReligionCastChange("padam", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Padam"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={khujaDhoshamOptions}
									getOptionLabel={(option) => option.name}
									value={religionAndCasteForm.khujaDhosham}
									onChange={(e, newValue) => handleReligionCastChange("khujaDhosham", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Khuja Dhosham"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid>
						</Grid>
					</>

				);
			case 2:
				return (
					<Grid container xs={12} spacing={2}>
						<Grid item xs={12} sm={6}>
							<Autocomplete
								options={countries}
								getOptionLabel={(option) => option.countryName}
								value={contactDetailsForm.country}
								onChange={(e, newValue) => handleContactDetails("country", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Country"
										variant="outlined"
										size="small"
										error={!!errors.country}
										helperText={errors.country}
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Autocomplete
								options={states}
								getOptionLabel={(option) => option.stateName}
								value={contactDetailsForm.state}
								onChange={(e, newValue) => handleContactDetails("state", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="State (2)"
										variant="outlined"
										size="small"
										error={!!errors.state}
										helperText={errors.state}
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Autocomplete
								options={districts}
								getOptionLabel={(option) => option.districtName}
								value={contactDetailsForm.district}
								onChange={(e, newValue) => handleContactDetails("district", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="District"
										variant="outlined"
										size="small"
										error={!!errors.district}
										helperText={errors.district}
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Autocomplete
								options={contactCities}
								getOptionLabel={(option) => option.cityName}
								value={contactDetailsForm.city}
								onChange={(e, newValue) => handleContactDetails("city", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="City (2)"
										variant="outlined"
										size="small"
										error={!!errors.city}
										helperText={errors.city}
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12}>
							<StyledTextField
								fullWidth
								label="Address"
								multiline
								rows={3}
								value={contactDetailsForm.address}
								onChange={(e) => handleContactDetails("address", e.target.value)}
								size="small"
								error={!!errors.address}
								helperText={errors.address}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<div style={{ marginTop: "-1px" }}>
								<PhoneInput
									country={"in"}
									value={contactDetailsForm.altMobile}
									onChange={(phone, countryData) => {
										handleContactDetails("altMobile", phone);
										handleContactDetails("altMobileCountryCode", countryData.dialCode); // ← save country code
									}}
									inputStyle={{
										fontSize: "14px",
										paddingLeft: "48px",
										borderColor: errors.altMobile ? "#d32f2f" : "#e0e0e0",
									}}
									buttonStyle={{
										backgroundColor: "transparent",
										borderColor: errors.altMobile ? "#d32f2f" : "#e0e0e0",
										borderRadius: "4px 0 0 4px",
									}}
									enableSearch={true}
									disableSearchIcon={false}
								/>

							</div>
						</Grid>

						<Grid item xs={12} sm={6}>
							<StyledTextField
								fullWidth
								label="Alternate Email  (1)"
								value={contactDetailsForm.altEmail}
								onChange={(e) => handleContactDetails("altEmail", e.target.value)}
								size="small"
								error={!!errors.altEmail}
								helperText={errors.altEmail}
							/>
						</Grid>
					</Grid>

				);
			case 3:

				return (
					<Grid container xs={12} spacing={2}>
						<Grid item xs={12} sm={6}>
							<StyledTextField
								fullWidth
								label="Application Filling Person Name"
								value={applicationInfo.applicationFillingPersonName || ""}
								onChange={(e) => handleApplicationDetails("applicationFillingPersonName", e.target.value)}
								size="small"
								error={!!errors.applicationFillingPersonName}
								helperText={errors.applicationFillingPersonName}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<div style={{ marginTop: "-1px" }}>


								<PhoneInput
									country={"in"}
									value={applicationInfo.applicationPersonMobileNo}
									onChange={(phone, countryData) => {
										handleApplicationDetails("applicationPersonMobileNo", phone);
										handleApplicationDetails("applicationPersonMobileCountryCode", countryData.dialCode); // ← save country code
									}}
									inputStyle={{
										fontSize: "14px",
										paddingLeft: "48px",
										borderColor: errors.applicationPersonMobileNo ? "#d32f2f" : "#e0e0e0",
									}}
									buttonStyle={{
										backgroundColor: "transparent",
										borderColor: errors.altMobile ? "#d32f2f" : "#e0e0e0",
										borderRadius: "4px 0 0 4px",
									}}
									enableSearch={true}
									disableSearchIcon={false}
								/>
							</div>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Autocomplete
								options={applicationSources}
								getOptionLabel={(option) => option.sourceName}
								value={applicationInfo.source}
								onChange={(e, newValue) => handleApplicationDetails("source", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Source"
										variant="outlined"
										size="small"
										error={!!errors.source}
										helperText={errors.source}
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Autocomplete
								options={branches}
								getOptionLabel={(option) => option.name}
								value={applicationInfo.nearestBranch}
								onChange={(e, newValue) => handleApplicationDetails("nearestBranch", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Nearest Branch"
										variant="outlined"
										size="small"
										error={!!errors.nearestBranch}
										helperText={errors.nearestBranch}
									/>
								)}
							/>
						</Grid>
					</Grid>

				);
			case 4:

				return (
					<Grid container xs={12} spacing={3} alignItems="flex-start">
						<Grid item xs={12} sm={uploadsProofsData.idProofType ? 6 : 12}
						>
							<Autocomplete
								options={idProofTypes}
								getOptionLabel={(option) => option.name}
								value={uploadsProofsData.idProofType}
								onChange={(e, newValue) => handleProofDataChange("idProofType", newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Id Proof"
										variant="outlined"
										size="small"
										error={!!errors.idProofType}
										helperText={errors.idProofType}
									/>
								)}
							/>
						</Grid>
						{uploadsProofsData.idProofType?.id == "aadharNumber" &&
							<Grid item xs={12} sm={6}>

								<StyledTextField
									fullWidth
									label={`${uploadsProofsData.idProofType?.name} Number`}
									value={uploadsProofsData.aadharNumber}
									onChange={(e) => {
										const value = e.target.value;
										if (/^\d{0,12}$/.test(value)) {
											handleProofDataChange("aadharNumber", value);
										}
									}
									}
									inputProps={{ maxLength: 12 }}
									size="small"
									error={!!errors.aadharNumber}
									helperText={errors.aadharNumber}
								/>
							</Grid>}
						{uploadsProofsData.idProofType?.id === "pan" && (
							<Grid item xs={12} sm={6}>
								<StyledTextField
									fullWidth
									label={`${uploadsProofsData.idProofType?.name} Number`}
									value={uploadsProofsData.panNumber}
									onChange={(e) => {
										const value = e.target.value.toUpperCase();
										if (/^[A-Z]{0,5}\d{0,4}[A-Z]{0,1}$/.test(value)) {
											handleProofDataChange("panNumber", value);
										}
									}}
									inputProps={{ maxLength: 10 }}
									size="small"
									error={!!errors.panNumber}
									helperText={errors.panNumber}
								/>
							</Grid>
						)}

						{uploadsProofsData.idProofType?.id === "passport" && (
							<Grid item xs={12} sm={6}>
								<StyledTextField
									fullWidth
									label={`${uploadsProofsData.idProofType?.name} Number`}
									value={uploadsProofsData.passportNumber}
									onChange={(e) => {
										const value = e.target.value.toUpperCase();
										if (/^[A-Z]{0,1}\d{0,7}$/.test(value)) {
											handleProofDataChange("passportNumber", value);
										}
									}}
									inputProps={{ maxLength: 8 }}
									size="small"
									error={!!errors.passportNumber}
									helperText={errors.passportNumber}
								/>
							</Grid>
						)}
						{/* {uploadsProofsData.idProofType?.id &&
							<>
								<Grid item xs={12} sm={6}>
									<StyledTextField
										fullWidth
										label="Name"
										variant="outlined"
										size="small"
										value={uploadsProofsData.name}
										onChange={(e) =>
											// setUploadsProofsData({ ...uploadsProofsData, name: e.target.value })
											handleProofDataChange("name", e.target.value)

										}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<StyledTextField
										fullWidth
										label="Surname"
										variant="outlined"
										size="small"
										value={uploadsProofsData.surName}
										onChange={(e) =>
											handleProofDataChange("surName", e.target.value)
										}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<StyledTextField
										fullWidth
										label="Father Name"
										variant="outlined"
										size="small"
										value={uploadsProofsData.fatherName}
										onChange={(e) =>
											handleProofDataChange("fatherName", e.target.value)
										}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<StyledTextField
										fullWidth
										label="Date Of Marriage"
										type="date"
										value={dateOfBirth ? new Date(dateOfBirth).toISOString().slice(0, 10) : ""}
										onChange={(e) => setDateofBirth(e.target.value)}
										size="small"
										// error={!!errors.dateOfBirth}
										// helperText={errors.dateOfBirth}
										inputProps={{
											max: new Date(new Date().setFullYear(new Date().getFullYear() - 18))
												.toISOString()
												.slice(0, 10),
										}}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<StyledTextField
										fullWidth
										label="Address"
										variant="outlined"
										size="small"
										value={uploadsProofsData.motherName}
										onChange={(e) =>
											handleProofDataChange("address", e.target.value)
										}
									/>
								</Grid>
							</>
						} */}
						<Grid container xs={12}>
							<Grid item xs={12} sm={6}>
								<Box display="flex" flexDirection="column" alignItems="center">
									<Typography variant="subtitle1" gutterBottom>
										Upload Profile Picture
									</Typography>
									<Button variant="contained" component="label">
										Choose File
										<input
											hidden
											accept="image/*"
											type="file"
											onChange={(e) => {
												const file = e.target.files[0];
												if (file) handleUpload("profilePic", file);
											}}
										/>
									</Button>

									{(uploadedFiles.profilePic || previousProfilePic) && (
										<Box mt={2}>
											<img
												src={
													uploadedFiles.profilePic instanceof File
														? URL.createObjectURL(uploadedFiles.profilePic)
														: previousProfilePic
												}
												alt="Profile Preview"
												style={{
													width: "150px",
													height: "150px",
													// objectFit: "cover",
													objectFit: "contain",
													borderRadius: "8px",
													marginTop: "8px",
												}}
											/>
										</Box>
									)}
								</Box>
							</Grid>


							{/* Aadhar Card Upload */}
							<Grid item xs={12} sm={6}>
								<Box display="flex" flexDirection="column" alignItems="center">
									<Typography variant="subtitle1" gutterBottom>
										Upload Id Proof
									</Typography>
									<Button variant="contained" component="label">
										Choose File
										<input
											hidden
											accept="application/pdf,image/*"
											type="file"
											onChange={(e) => {
												const file = e.target.files[0];
												if (file) handleUpload("aadharCard", file);
											}}
										/>
									</Button>




									{(uploadedFiles.aadharCard || previousAadharCard) && (
										<Box mt={2}>
											<img
												src={
													uploadedFiles.aadharCard instanceof File
														? URL.createObjectURL(uploadedFiles.aadharCard)
														: previousAadharCard
												}
												alt="Id Proof Preview"
												style={{
													width: "150px",
													height: "150px",
													// objectFit: "cover",
													objectFit: "contain",
													borderRadius: "8px",
													marginTop: "8px",
												}}
											/>
										</Box>
									)}
								</Box>
							</Grid>
						</Grid>
					</Grid>
				);
			case 5:
				return (
					<>
						<Grid container xs={12} spacing={2}>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={smokeOptions}
									getOptionLabel={(option) => option.name}
									value={lifeStileAndMaritalStatus.smoke}
									onChange={(e, newValue) => handleLifeStyleAndMaritalStatus("smoke", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Do you Smoke?"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									options={drinkOptions}
									getOptionLabel={(option) => option.name}
									value={lifeStileAndMaritalStatus.drink}
									onChange={(e, newValue) => handleLifeStyleAndMaritalStatus("drink", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Do you Drink?"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</Grid>

							{/* <Grid item xs={12} sm={6}>
								<Autocomplete
									options={foodPreferences}
									getOptionLabel={(option) => option.name}
									value={lifeStileAndMaritalStatus.food}
									onChange={(e, newValue) => handleLifeStyleAndMaritalStatus("food", newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Food Preference"
											variant="outlined"
											size="small"
											error={!!errors.food}
											helperText={errors.food}
										/>
									)}
								/>
							</Grid> */}
							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={hobbies}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.hobbies || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("hobbies", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Hobbies"
											variant="outlined"
											size="small"
											error={!!errors.hobbies}
											helperText={errors.hobbies}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={interests}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.interests || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("interests", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Interests"
											variant="outlined"
											size="small"
											error={!!errors.interests}
											helperText={errors.interests}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={favouriteMusic}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.favouriteMusic || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("favouriteMusic", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Favourite Music"
											variant="outlined"
											size="small"
											error={!!errors.favouriteMusic}
											helperText={errors.favouriteMusic}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={sports}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.sports || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("sports", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Sports"
											variant="outlined"
											size="small"
											error={!!errors.sports}
											helperText={errors.sports}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={fitnessActivities}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.fitnessActivities || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("fitnessActivities", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Fitness Activities"
											variant="outlined"
											size="small"
											error={!!errors.fitnessActivities}
											helperText={errors.fitnessActivities}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={favouriteCuisine}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.favouriteCuisine || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("favouriteCuisine", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Favourite Cuisine"
											variant="outlined"
											size="small"
											error={!!errors.favouriteCuisine}
											helperText={errors.favouriteCuisine}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={favouriteReads}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.favouriteReads || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("favouriteReads", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Favourite Reads"
											variant="outlined"
											size="small"
											error={!!errors.favouriteReads}
											helperText={errors.favouriteReads}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={preferredMovies}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.preferredMovies || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("preferredMovies", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Preferred Movies"
											variant="outlined"
											size="small"
											error={!!errors.preferredMovies}
											helperText={errors.preferredMovies}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={preferredDressStyle}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.preferredDressStyle || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("preferredDressStyle", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Preferred Dress Style"
											variant="outlined"
											size="small"
											error={!!errors.preferredDressStyle}
											helperText={errors.preferredDressStyle}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={favouriteFood}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.favouriteFood || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("favouriteFood", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Favourite Food"
											variant="outlined"
											size="small"
											error={!!errors.favouriteFood}
											helperText={errors.favouriteFood}
										/>
									)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Autocomplete
									multiple
									options={spokenLanguages}
									getOptionLabel={(option) => option?.name || ""}
									value={lifeStileAndMaritalStatus.spokenLanguages || []}
									onChange={(e, newValue) =>
										handleLifeStyleAndMaritalStatus("spokenLanguages", newValue)
									}
									isOptionEqualToValue={(option, value) => option.id === value.id}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Spoken Languages"
											variant="outlined"
											size="small"
											error={!!errors.spokenLanguages}
											helperText={errors.spokenLanguages}
										/>
									)}
								/>
							</Grid>

						</Grid>
					</>

				);
			default:
				return null;
		}
	};
	return (
		<Container maxWidth={false} sx={{ maxWidth: "none" }}>
			{type != "edit" && <Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexDirection: { xs: "column", md: "row" },
					px: { xs: 0, sm: 25 },
					py: { xs: 2 }
				}}
			>
				<Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
					<img
						src="/images/Frame 148.png"
						alt="Logo"
						style={{
							maxWidth: "330px",
							width: "100%",
							height: "auto",
						}}
					/>
				</Box>

				<Box
					sx={{
						position: "relative",
						width: 180,
						height: 180,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						variant="determinate"
						value={100}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#F0E0D0",
						}}
					/>
					<CircularProgress
						variant="determinate"
						value={75}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#B56E2C",
						}}
					/>
					<Box sx={{ textAlign: "center" }}>
						<Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>{profileStrength}%</Typography>
						<Typography sx={{ color: "#B56E2C" }}>completed</Typography>
					</Box>
				</Box>
			</Box>}
			<FormContainer elevation={0} sx={{ ...styles.formCard }}>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<div className="form-content">
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<SectionTitle sx={{ ...styles.textstyle }} variant="h6">
							{/* {sections[activeTab]} */} Profile Detailes
						</SectionTitle>
						{(type != "edit" && profileStrength >= 65) && <Button
							variant="outlined"
							color="secondary"
							sx={{ ...styles.skipButton }}
							onClick={() => {
								window.location.href = "/profile/DetaliesDashbord?type=suggested-profiles";
							}}


						>
							Skip
						</Button>}


					</div>

					{/* <Tabs value={activeTab} variant="scrollable" scrollButtons="auto">
						{sections.map((label, index) => (
							<Tab
								key={label}
								label={label}
								disabled
								style={{ fontWeight: "bold", fontSize: "13px", color: "black" }}
							/>
						))}
					</Tabs> */}

					<Tabs
						value={activeTab}
						onChange={(event, newValue) => {
							apiCall.current = false
							if (type === "edit" || userType) {
								setActiveTab(newValue);
							}
						}}
						variant="scrollable"
						scrollButtons="auto"
					>
						{sections.map((label, index) => (
							<Tab
								key={label}
								label={label}
								value={index}
								disabled={!(type === "edit" || userType)} // disables tab clicking if not in edit mode
								style={{
									fontWeight: "bold",
									fontSize: "13px",
									color: "black"
								}}
							/>
						))}
					</Tabs>
					<Box mt={4}>
						<Grid container xs={12} spacing={2} sx={{ ml: 0 }}>
							<Grid item xs={12}>
								{renderTabContent()}

							</Grid>
						</Grid>

						<Box display="flex" justifyContent="space-between" mt={4}>
							<Button
								sx={{ ...styles.searchcancel }}

								onClick={handleBack}
								disabled={activeTab === 0}
							>
								Back
							</Button>
							<Button variant="contained" onClick={handleNext} style={{ ...styles.search }}>
								{activeTab === sections.length - 1 ? "Submit" : "Next"}
							</Button>
						</Box>
					</Box>
				</div>
			</FormContainer>
		</Container>
	);
};

export default PersonalDetailsForm;
